// Testimonials.js
import React from "react";
import TestimonialVideoGrid from "./TestimonialVideoGrid";
import TestimonialCard from "./TestimonialCard";
import "./Testimonials.css";
import TestimonialCardGrid from "./TestimonialCardGrid";

export default function Testimonials() {
  const videos = [
    {
      src: "https://www.w3schools.com/html/mov_bbb.mp4",
      poster: "poster1.jpg",
    },
    {
      src: "https://www.w3schools.com/html/mov_bbb.mp4",
      poster: "poster2.jpg",
    },
    {
      src: "https://www.w3schools.com/html/mov_bbb.mp4",
      poster: "poster3.jpg",
    },
  ];

  const testimonials = [
    {
      companyLogo: "https://cdn.mupende.com/raw/7Do8bC.svg",
      companyLogoAlt: "Daimler Truck Financial Services Logo",
      quote: "Innovative ideas backed by solid technical expertise.",
      content:
        "During his time working in my department, Charles provided valuable support and ideas in using machine learning for process automation. His technical insights and innovative approach were greatly appreciated.",
      clientName: "Benjamin Eule",
      clientTitle: "Director Credit Operations Europe and South America",
      clientCompany: "Daimler Truck Financial Services",
      clientAvatar:
        "https://media.licdn.com/dms/image/v2/D4E03AQHMqKwUkv-c4Q/profile-displayphoto-shrink_200_200/B4EZaZT3oVHIAY-/0/1746328845877?e=1762992000&v=beta&t=86M7PpkPNuiiAVO5dfiJM1rZTvD3Zc4F7uGihZ07w-0",
      clientAvatarAlt: "Benjamin Eule Avatar",
    },
    {
      companyLogo: "https://cdn.mupende.com/raw/1oBvz0.png",
      companyLogoAlt: "KeLO Logo",
      quote: "Pragmatic solutions that actually work.",
      content:
        "Charles helped us automate our mailing systems with a clear, results-driven approach. His ability to turn complex challenges into efficient, working solutions had a lasting positive impact on our operations.",
      clientName: "Dieter Cichon",
      clientTitle: "CEO",
      clientCompany: "KeLo Kopiertechnik",
      clientAvatar: "https://cdn.mupende.com/raw/qcWEKn.png",
      clientAvatarAlt: "Dieter Cichon Avatar",
    },

    {
      companyLogo: "https://cdn.mupende.com/raw/MVWh29.svg",
      companyLogoAlt: "Starfish Logo",
      quote: "Technical understanding meets execution.",
      content:
        "As a strategic partner providing advisory and technology services, I regularly collaborate with Charles on building software products in the payments space. He combines strong technical understanding with ambitious thinking and a clear focus on practical execution. Working with him is always productive and technically engaging.",
      clientName: "Markus Kuhnt",
      clientTitle: "Co-Founder",
      clientCompany: "Starfish",
      clientAvatar:
        "https://media.licdn.com/dms/image/v2/D4E03AQFIh3rHrpuLtQ/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1697011279075?e=1762992000&v=beta&t=hVVYHnSLG5GSx6jOJysUOm2oOiuYt6myMHKTBPeYJOE",
      clientAvatarAlt: "Markus Kuhnt Avatar",
    },
    {
      companyLogo: "https://cdn.mupende.com/raw/7Do8bC.svg",
      companyLogoAlt: "Daimler Truck Financial Services Logo",
      quote: "A strategic thinker who delivers results.",
      content:
        "As a Product Manager, he significantly contributed to advancing Daimler Truck Pay as a B2B payments platform. His strategic thinking and execution capabilities were instrumental to our success.",
      clientName: "Clint Dawson",
      clientTitle: "Head of Payment and Financial Integration",
      clientCompany: "Daimler Truck Financial Services",
      clientAvatar:
        "https://media.licdn.com/dms/image/v2/D4E03AQE7u_tiLTIfBA/profile-displayphoto-shrink_800_800/B4EZZsSU5sGYAc-/0/1745573466319?e=1762992000&v=beta&t=GIt0ucalw2id_xZ-jRUA97CKAMmfMYjHR75CMQcrWnk",
      clientAvatarAlt: "John Doe Avatar",
    },
  ];

  return (
    <section className="testimonials" id="testimonials">
      <div className="testimonials-eyebrow">TESTIMONIALS</div>
      <div className="testimonials-desc">
        Why software companies trust me to help them scale faster.
      </div>
      <TestimonialCardGrid testimonials={testimonials} />
    </section>
  );
}
